export function isUserOnboarded(
  user:
    | {
        firstname?: string | null;
        lastname?: string | null;
        professionModel?: unknown;
        mainSpecialtyModel?: unknown;
      }
    | null
    | undefined
): boolean {
  // NOTE: mainSpecialtyModel check removed until specialty selection step is
  // implemented in onboarding v4. Re-add when Phase 2 lands.
  return Boolean(
    user && user.firstname && user.lastname && user.professionModel
  );
}
